
const m = window.require("@popperjs/core");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
